import styled from '@emotion/styled';

export const StyledTableShell = styled('div')(({ theme }) => ({
  '& .actions-cell': {
    opacity: 0,
    transition: 'opacity 150ms ease',
  },
  '& .schema-list-table': {
    borderCollapse: 'collapse',
  },
  '& .schema-list-table tbody td': {
    border: 'none',
    borderBottom: `1px solid ${
      theme.colorScheme === 'dark' ? theme.colors.dark[5] : '#F9FAFB'
    }`,
    borderRight: 'none',
    fontSize: '0.875rem',
    padding: '10px 16px',
    verticalAlign: 'middle',
  },
  '& .schema-list-table tbody tr': {
    transition: 'background-color 100ms ease',
    '&:hover': {
      backgroundColor:
        theme.colorScheme === 'dark' ? 'rgba(255, 255, 255, 0.015)' : '#FAFBFC',
    },
    '&:hover .actions-cell': {
      opacity: 1,
    },
  },
  '& .schema-list-table tbody tr:last-child td': {
    borderBottom: 'none',
  },
  '& .schema-list-table thead th': {
    '&:nth-of-type(8)': {
      textAlign: 'right',
    },
    '&:nth-of-type(9)': {
      textAlign: 'right',
    },
    backgroundColor:
      theme.colorScheme === 'dark' ? theme.colors.dark[6] : '#FAFBFC',
    border: 'none',
    borderBottom: `1px solid ${
      theme.colorScheme === 'dark' ? theme.colors.dark[5] : '#E5E7EB'
    }`,
    borderRight: 'none',
    color: theme.colorScheme === 'dark' ? theme.colors.gray[6] : '#6B7280',
    fontSize: '0.6875rem',
    fontWeight: 600,
    letterSpacing: 'normal',
    padding: '10px 16px',
    textTransform: 'none',
    whiteSpace: 'nowrap',
  },
}));

export const StyledHeaderCell = styled('th')<{ $canSort: boolean }>(
  ({ $canSort }) => ({
    cursor: $canSort ? 'pointer' : 'default',
  }),
);

export const StyledEmptyStateCell = styled('td')({
  border: 'none',
  textAlign: 'center',
});

export const StyledBodyRow = styled('tr')<{ $isDraft: boolean }>(
  ({ $isDraft }) => ({
    cursor: $isDraft ? 'pointer' : 'default',
  }),
);
